import _ from 'underscore';
import { useMemo, useCallback } from 'react';

import {
  createSpec,
  specTypes,
  usePagination,
  useDataRefId,
  useRefetch,
} from '@bingads-webui-react/overreact';

import {
  fetchRequestContract as fetchCollRequestContract,
  fetchResponseContract as fetchCollResponseContract,
} from '../spec/coll-fetch';
import { environmentLookupFn } from '../../../environment/index';

const fetchCollSpec =
  createSpec(
    fetchCollRequestContract, fetchCollResponseContract,
    specTypes.PAGINATION, null, environmentLookupFn
  );
const refetchCollSpec =
  createSpec(
    fetchCollRequestContract, fetchCollResponseContract,
    specTypes.REFETCH, null, environmentLookupFn
  );

export function useCampaignCriterions(dataLocator, config = {}) {
  const dataRefId = useDataRefId();
  const paginationConfig = useMemo(() => ({
    fetchVariables: {
      ...dataLocator,
    },
  }), [dataLocator]);
  const page = usePagination(dataRefId, fetchCollSpec, paginationConfig);

  const { refetch = {} } = config;
  const refetchFn = useRefetch(dataRefId, refetchCollSpec, refetch);

  const refresh = useCallback((param) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
    });
  }, [dataLocator, refetchFn]);

  const [data, { isLoading, ...method }] = page;

  return [data, _.extend({}, method, {
    isLoading,
    refresh,
  })];
}
